import { OnDestroy, OnInit } from '@angular/core';
import { Plugin } from './plugin.component';

export class ChassisPlugin extends Plugin implements OnInit, OnDestroy {
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/chassis-plugin.component.ts